import styled from 'styled-components';
import {Button} from 'global/styles/styles.js';

const S = {};

S.AccountFreebet = styled.div`
    width: 100%;
`;

S.FreebetList = styled.div`
    margin: 0 16px;
`;

S.FreebetActiveList= styled.div`
   margin-top: 1.5rem;
`;
S.FreebetHistoryList= styled(S.FreebetActiveList)``;

S.FreebetFakeTable = styled.div``;

S.Th = styled.div`
    color: rgba(0, 0, 0, 0.87);
    text-align: center;
    font-weight: 400;
    line-height: 1;
    border-top: 0;
    overflow: hidden;
    font-size: 10px;
    text-overflow: ellipsis;
    
    & > span {
        overflow: hidden;
        text-overflow: ellipsis;
    }
    
    &.freebet_id {
        width: 10%;
    }
    &.freebet_amount{
      width: 15%;
    }
    &.freebet_name{
        width: 45%;
    }
    &.freebet_expirationDate{
       width: 30%;
    }
`;

S.Thead = styled.div`
    display: flex;
    border-bottom: 2px solid #D32F2F;
    padding-bottom: 5px;
    margin-bottom: 10px;
    
    ${S.Tr}{
       & > ${S.Th}{}
    }
`;

S.Tr = styled.div`
  display: flex;
  width: 100%;
`;
S.Td = styled(S.Th)`
    border: none; 
    color: rgba(0, 0, 0, 0.87);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: flex;
    justify-content: center;
    align-items: center;

        &.freebet-id{
            width: 10%;
        }
        &.freebet-amount{
        width: 15%;
        }
        &.freebet-name{
            width: 45%;
        }
        &.freebet-expirationDate{
        width: 30%;
        }
`;

S.Tbody = styled.div`
    ${S.Tr}{
        height: 52px;
        font-size: 10px;
        margin-bottom: 3px;
        border-radius: 3px;

        &:nth-child(odd){
          background-color: #fff;
        }
        &:nth-child(even){
          background-color: rgba(255, 255, 255, 0.6);
        }
    }
`;

S.NoResult = styled.div`
    display: flex;
    height: 40px;
    justify-content: center;
    align-items: center;
`;

S.FreebetFilters = styled.div`
    display: flex;
    flex-direction: column;
`;

S.FreebetFiltersBtns = styled.div`
    display: flex;
    flex-grow: 0;
`;

S.FilterBtn = styled(Button)`
    position: relative;
    flex: 1;
    color: #fff;
    height: 42px;
    border-radius: 0;
    font-size: 12px;
    outline: none;
    background-color: ${({isActive})=>(isActive == true ? '#D32F2F ': '#C62828')};
  
        &:after {
            content: '';
            position: absolute;
            left: 50%;
            z-index: 1;
            bottom:-17px;
            width:0;
            height:0;
            border-top: 10px solid #D32F2F;
            border-bottom:10px solid transparent;
            border-left:10px solid transparent;
            border-right:10px solid transparent;
        }    
`;

S.FreebetFiltersDates = styled.div`
    display: flex;
    height: 42px;
    margin: 1rem;
    & > div{
        flex: 1;
    }
`;

S.DateLabel = styled.div`
    display: flex;
    font-weight: 400;
    color: ${({theme:{$datepickerLabelColor}})=> $datepickerLabelColor};
    background-color: ${({theme:{$datepickerLabelBg}})=> $datepickerLabelBg};
    padding-left: 0.75rem;
    justify-content: center;
    align-items: center;
    border-radius: 3px;
    font-size: 14px;
`;

S.DateIcon = styled.i`
    position: absolute;
    right: 0;
    top: 0;
    display: flex;
    height: 100%;
    width: 33px;
    font-size: 1.67rem;
    color: #565656;
    justify-content: center;
    align-items: center;
    pointer-events: none;
`;

S.Datepicker = styled.div`
   position: relative;
   display: flex;
   height: 42px;
   width: 100%;
   border: 1px solid rgba(0, 0, 0, 0.24);
   border-radius: 3px;

   &:first-child {
    margin-right: 10px;
   }

   input[type="date"] {
    -o-appearance: none;
    -ms-appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    flex: 1 1 0%;
    padding: 0;
    padding-left: 10px;
    background-color: ${({theme:{$datepickerInputBg}})=> $datepickerInputBg};
    border: none;
    border-radius: 0;
    height: 100%;
    font-size: 14px;
    font-weight: 500;
    width: 100%;
    color: ${({theme:{$datepickerInputColor}})=> $datepickerInputColor};
    outline: none;

    &::-webkit-calendar-picker-indicator {
        padding: 0;
        opacity: 0;
        margin: 0;
    }
   }
`;

export default S;